import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";
import LocaleUtils from "qwc2/utils/LocaleUtils";

class ComponentSubsTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    toComponent(item) {
        if (item.href) {
            const href = FeatureUtils.resolveValues(item, item.href);
            this.openComponentUrl(href);
        } else {
            this.openComponent(item);
        }
    }

    renderChild(cchild) {
        return (
            <tr key={cchild.href}>
                <td>{cchild.title}</td>
                <td><a href='#' onClick={() => this.toComponent(cchild)}><span className={'icon icon_clickable icon-eye'}></span></a></td>
            </tr>
        );
    }

    renderTable(children) {
        return (
            <table className='feature-ajax-table'>
                <thead>
                <tr>
                    <th>Name</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {children.map(l => this.renderChild(l))}
                </tbody>
            </table>
        );
    }

    addComponentWindow(data) {
        const component = {
            detailWindowType: 'component',
            addComponentTo: 'component',
            clickPoint: data.geometry.coordinates,
            belongsTo: data,
            types: {
                typeLabel: LocaleUtils.trmsg("featuredetails.addcomponent")
            },
            properties: {
                id: null,
                uuid: null,
            }
        };
        this.props.setDetailWindow(this.props.windowId, component);
    }

    render() {
        let content = (
            <p>Es sind keine untergeordneten Bauteile vorhanden.</p>
        );
        if (this.props.feature && this.props.feature.links) {
            const links = this.props.feature.links;
            const children = [];
            for (let i = 0; i < links.length; i++) {
                if (links[i].rel === 'childitem') {
                    children.push(links[i]);
                }
            }
            content = this.renderTable(children);
        }
        return (
            <div className="feature-details-component-subs">
                {content}

                <div className="mt-3">
                    <button className="button" onClick={() => this.addComponentWindow(this.props.feature)}>
                        {LocaleUtils.tr("featuredetails.addcomponent")}
                    </button>
                </div>
            </div>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(ComponentSubsTab);
